import styles from './excellence-loader.module.scss'
import logoSVG from '../../../assets/excellence.svg'
import classNames from "classnames"

export interface ICustomLoaderComponent {
  progress?: number
  showAnimation?: boolean
}

export function ExcellenceLoader({ progress, showAnimation }: ICustomLoaderComponent) {
  return (
    <div className={classNames(styles.excellence_loading__screen_wrap)}>
      <div className={styles.content__wrap}>
        <div className={styles.overlay__elem} />
        {<img src={logoSVG} alt="loading..." className={styles.loading__logo} />}
        <div className={classNames(styles.progressPercents)}>
          {progress !== undefined ? (
            (progress * 100).toFixed() + '%'
          ) : (
            <div className={classNames(styles.progress__text)}>Initializing...</div>
          )}
        </div>
        <div className={classNames(styles.loading__text)}>
          {showAnimation ? 'Loading...' : 'Please wait'}
        </div>
      </div>
    </div>
  )
}

export default ExcellenceLoader
